'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      direction: ''
    };
  },
  mounted: function mounted() {},

  filters: {},
  computed: {
    routerTransition: function routerTransition() {
      return !this.direction ? '' : 'app-slide-' + (this.direction === 'forward' ? 'in' : 'out');
    }
  },
  watch: {
    '$route': function $route(to, from) {
      // if (to.name === 'login') {

      //   this.direction = false;
      //   return;
      // }
      var toDepth = to.path.split('/').length;
      var fromDepth = from.path.split('/').length;
      this.direction = toDepth < fromDepth ? 'back' : 'forward';
    }
  },
  methods: {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app.vue
// module id = 235
// module chunks = 14